module.exports = require("./ar-BH.d.ts");